import { useNavigate } from 'react-router-dom';
import { useResetPasswordMutation } from 'shared/hooks/queries/use-reset-password-mutation';
import { Paths } from 'shared/routes/paths';

export const useResetPassword = () => {
  const navigate = useNavigate();
  const { mutateAsync, error, reset, isPending, isSuccess } =
    useResetPasswordMutation();

  const resetPassword = async ({
    password,
    code,
  }: {
    password: string;
    code: string;
  }) => {
    try {
      await mutateAsync({ password, code });
    } catch {
      // the mutation's `error` state carries the form error; the page has no catch
      return;
    }
    navigate(Paths.Home);
  };

  return {
    resetPassword,
    error: error?.kind,
    isLoading: isPending,
    isSuccess,
    reset,
  };
};
